import {
    Box, chakra, Button
} from '@chakra-ui/react';

export const DucsModalWrapper = chakra(Box, {
    baseStyle: {
        maxHeight: '90vh',
        minWidth: '50%',
        maxWidth: '80%',
        backgroundColor: 'primary.50',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    }
});

export const DucsModalContent = chakra(Box, {
    baseStyle: {
        flex: 1,
        w: '100%',
        overflow: 'auto',

        ['.ppp-ducs-overridable.ppp-row-type-standard']: { margin: '0px' },
        ['.ppp-ducs-overridable.ppp-module-type-textbox']: {
            h: '108px',
            overflow: 'auto',
            m: '0 20px',
            fontSize: '16px'
        },
        ['.ppp-ducs-overridable.ppp-row-type-heading']: {
            m: 0,
            p: 0,
            boxShadow: 'none'
        },
        ['.ppp-ducs-overridable.ppp-video-row-type-standard.ppp-row-type-standard.ppp-row-show h2']: {
            p: '30px 20px 0',
            fontSize: '30px',
            w: '100%',
            color: 'primary.500'
        },
        ['.ql-editor']: { paddingTop: 0 }
    }
});

export const Footer = chakra(Box, {
    baseStyle: {
        h: '60px',
        p: '7px'
    }
});

export const DucsCarousel = chakra(Box, {
    baseStyle: {
        display: 'flex',
        marginTop: '10px'
    }
});

export const CarouselIndicators = chakra(Box, {
    baseStyle: {
        display: 'flex',
        margin: '10px'
    }
});

export const CarouselIndicator = chakra(Box, {
    baseStyle: {
        w: '10px',
        h: '10px',
        borderRadius: '5px',
        m: '3px',
        cursor: 'pointer'
    }
});

export const CarouselButton = chakra(Button, { baseStyle: { w: '30px' } });

export const ErrorContent = chakra(Box, {
    baseStyle: {
        m: '20px',
        w: '500px',
        h: '400px'
    }
});

export const ErrorImage = chakra('img', { baseStyle: { m: '2px' } });
